import {
    type FC
} from "react";
import type ITableCaptionProps from "./type";
import {
    useTableContext
} from "../../context";
import Text from "../../../text";

const TableCaption: FC<ITableCaptionProps> = ({
    customTheme: customThemeProp,
    children,
    ...props
}) => {
    const context = useTableContext({
        part: "Caption"
    });

    if(!context) {
        return null;
    }

    return <Text
        {...props}
        customTheme={customThemeProp ?? context.customTheme}
        variant="bodySmallSize"
        color="mid"
    >
        {children}
    </Text>;
};
export default TableCaption;
